import {
    IconPauseFill,
    IconPlayOutline,
    IconReplayGraphRounded,
    IconVolumeFill,
    IconVolumeMutedFill
} from 'assets/svg/sprite'
import { formatVideoTime } from 'lib/dayjs'

import ProgressBar from '../ProgressBar/ProgressBar'

import './_videoPlayerControls.scss'

interface Props {
    playing: boolean
    setPlaying: React.Dispatch<React.SetStateAction<boolean>>

    volumeBarShowing: boolean

    muted: boolean
    setMuted: (_muted: boolean) => void

    progressData: {
        played: number
        playedSeconds: number
        loaded: number
        loadedSeconds: number
    }

    getVideoElement: () => HTMLVideoElement | null
    handleOnSeekChange: (fraction: number) => void

    minimized: boolean
    videoDuration: any
    displayDuration?: number

    showReplayGraph: boolean
    setShowReplayGraph: React.Dispatch<React.SetStateAction<boolean>>

    isOwner: boolean
}
const VideoPlayerControls = ({
    playing,
    setPlaying,
    volumeBarShowing,
    muted,
    setMuted,
    progressData,
    getVideoElement,
    handleOnSeekChange,
    minimized,
    videoDuration,
    displayDuration,
    showReplayGraph,
    setShowReplayGraph,
    isOwner
}: Props) => {
    return (
        <div className='videoPlayerControls'>
            <div className='videoPlayerControls__progress'>
                <ProgressBar
                    getVideoElement={getVideoElement}
                    onSeek={handleOnSeekChange}
                />
            </div>

            <div className='videoPlayerControls__actions'>
                <div className='videoPlayerControls__actions--left'>
                    <div
                        className='videoPlayerControls__action videoPlayerControls__action--play'
                        onClick={e => {
                            e.stopPropagation()

                            setPlaying(prev => !prev)
                        }}
                    >
                        {minimized ? (
                            playing ? (
                                <IconPauseFill color='#2894FF' />
                            ) : (
                                <IconPlayOutline color='#FFF' />
                            )
                        ) : playing ? (
                            <IconPauseFill color='#FFF' />
                        ) : (
                            <IconPlayOutline color='#FFF' />
                        )}
                    </div>

                    {!minimized && (
                        <>
                            <div
                                className={`videoPlayerControls__action videoPlayerControls__action--volume ${
                                    volumeBarShowing
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                <div
                                    className='videoPlayerControls__action--volume-icon'
                                    onClick={e => {
                                        e.stopPropagation()
                                        setMuted(!muted)
                                    }}
                                >
                                    {muted ? (
                                        <IconVolumeMutedFill />
                                    ) : (
                                        <IconVolumeFill />
                                    )}
                                </div>
                            </div>

                            <div className='videoPlayerControls__duration'>
                                <span className='videoPlayerControls__duration--played'>
                                    {formatVideoTime(
                                        progressData.playedSeconds
                                    )}
                                </span>

                                <span className='videoPlayerControls__duration--divider'>
                                    {' / '}
                                </span>

                                <span className='videoPlayerControls__duration--loaded'>
                                    {formatVideoTime(
                                        displayDuration ??
                                            videoDuration
                                    )}
                                </span>
                            </div>
                        </>
                    )}
                </div>

                {!minimized && (
                    <div className='videoPlayerControls__actions--right'>
                        {isOwner && (
                            <button
                                type='button'
                                className={`videoControls__replayGraphButton ${
                                    showReplayGraph
                                        ? 'active'
                                        : ''
                                }`}
                                onClick={e => {
                                    e.stopPropagation()

                                    setShowReplayGraph(
                                        prev => !prev
                                    )
                                }}
                                aria-label={
                                    showReplayGraph
                                        ? 'Hide replay graph'
                                        : 'Show replay graph'
                                }
                            >
                                <IconReplayGraphRounded
                                    color={
                                        showReplayGraph
                                            ? '#fff'
                                            : '#8a8a8a'
                                    }
                                />
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default VideoPlayerControls